/** Lab preferences (internal defaults applied to every run started from the simple flow). Stored per browser. */
const KEY = "listing_ai_prefs";

export const DEFAULT_PREFS = {
  pipeline_version: null, // null -> service default
  language: "nb-NO",
  enable_generative_enhancement: null, // null -> pipeline version default
  strict_fidelity: null, // null -> pipeline version default
  webhook_enabled: true, // sends to the built-in test sink
  webhook_url: "",
  virtual_staging: true, // "La DigiHome vurdere" - auto-propose staging for empty rooms (long-term only). false -> off
};

export function getPrefs() {
  try {
    return { ...DEFAULT_PREFS, ...(JSON.parse(localStorage.getItem(KEY) || "{}")) };
  } catch {
    return { ...DEFAULT_PREFS };
  }
}

export function setPrefs(p) {
  localStorage.setItem(KEY, JSON.stringify({ ...getPrefs(), ...p }));
}

export function buildJobOptions(prefs, config) {
  const version = prefs.pipeline_version || config?.default_pipeline_version;
  const v = (config?.pipeline_versions || []).find((x) => x.version === version) || {};
  const gen = prefs.enable_generative_enhancement == null ? Boolean(v.enable_generative_enhancement) : prefs.enable_generative_enhancement;
  const strict = prefs.strict_fidelity == null ? v.strict_fidelity !== false : prefs.strict_fidelity;
  const webhookUrl = prefs.webhook_enabled ? (prefs.webhook_url || config?.webhook_sink_url) : null;
  return { version, gen, strict, webhookUrl, language: prefs.language || "nb-NO", staging: prefs.virtual_staging !== false };
}

const RIGHTS_KEY = "listing_ai_rights_confirmed";
export const rightsConfirmedOnce = () => localStorage.getItem(RIGHTS_KEY) === "1";
export const rememberRights = () => localStorage.setItem(RIGHTS_KEY, "1");

export function detectSource(url) {
  if (/airbnb\./i.test(url)) return "airbnb";
  if (/finn\.no/i.test(url)) return "finn";
  return null;
}
